import React from 'react';

const VisuallyHidden = ({ children }) => <span className="visually-hidden">{children}</span>;

export default VisuallyHidden;
